export default __webpack_public_path__ + "static/media/group-icon.d31d029e.svg";